import ApiService from "../core/service/ApiService"
import { sendToLogServer } from "../core/service/BusinessLogicService"
import { apigateway } from "../intances/apigateway"
import { getUserToken } from "./authorization"

export function getOrders(
  tunnelData,
  { shopId, clientNameOrOPL, statusOPLs, sort, orderStorageTime, rowsDisplayed, offset }
) {
  const statusOPLStringURLParam = statusOPLs && statusOPLs.length > 0 ? statusOPLs.join(",") : null

  const params = new URLSearchParams()
  const queryParameters = [
    { label: "statusOPLs", value: statusOPLStringURLParam },
    { label: "supplierId", value: shopId },
    { label: "sortingDate", value: sort },
    { label: "nameOrOrderNumber", value: clientNameOrOPL },
    { label: "orderStorageTime", value: orderStorageTime },
    { label: "rowsDisplayed", value: rowsDisplayed },
    { label: "offset", value: offset }
  ]

  queryParameters.forEach((param) => {
    if (param.value !== null) {
      params.append(param.label, param.value)
    }
  })
  const API_URL_GET_ORDERS = `/middle-business-service/api/v2/resume-order/search-pageable?`

  return apigateway(tunnelData)
    .get(API_URL_GET_ORDERS + params)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export function patchOrder({ tunnelData, opl, values }) {
  const headers = {
    Authorization: `Bearer ${getUserToken()}`,
    Accept: "*/*"
  }
  return apigateway(tunnelData)
    .post(`/middle-business-service/api/v3/order/${opl}`, values, { headers: headers })
    .then((res) => {
      return {
        success: true,
        values: values
      }
    })
    .catch((error) => {
      sendToLogServer("ERROR", "There was an error in the v3 /order/opl endpoint" + opl + " : " + JSON.stringify(error))
      console.error("patchOrder Error", error)
      return false
    })
}

export function getOrderByOPL(localTunnelData, opl) {
  try {
    const headers = {
      Authorization: `Bearer ${localTunnelData?.access_token}`,
      Accept: "*/*"
    }
    const API_URL_GET_ORDER = `${localTunnelData.apiUrl}middle-business-service/api/v2/order/${opl}`

    return ApiService.getForEvollisApi(API_URL_GET_ORDER, headers)
      .then((response) => {
        return response
      })
      .catch((error) => {
        throw error
      })
  } catch (error) {
    console.error(error)
    return null
  }
}

export function getScoreAMLAlertCodesByOpl(tunnelData, opl) {
  try {
    const API_URL_GET_SCORE_AML_ALERTS_ORDER = `${tunnelData.apiUrl}middle-business-service/api/v2/order/${opl}/score-aml-alerts`

    const headers = {
      Authorization: `Bearer ${tunnelData?.access_token}`,
      Accept: "*/*"
    }
    return ApiService.getForEvollisApi(API_URL_GET_SCORE_AML_ALERTS_ORDER, headers)
      .then((response) => {
        return response
      })
      .catch((error) => {
        throw error
      })
  } catch (error) {
    console.error(error)
    return null
  }
}
